/* eslint-disable spaced-comment */
/* eslint-disable no-unused-vars */
/* eslint-disable import/no-extraneous-dependencies */
import { applyMiddleware, createStore } from 'redux';
import flightBookingReducer from './flightBooking/flightBookingReducer';

//flight validation middleware
const flightValidation = store => next => action => {
  console.log(`Action : ${JSON.stringify(action)}`);

  const upcomingState = [action].reduce(flightBookingReducer, store.getState());
  if (upcomingState.flights.length >= 3) {
    document.getElementById('lws-addCity').setAttribute('disabled', '');
    document.getElementById('lws-addCity').style.cursor = 'not-allowed';
    alert("Please remember! You have completed your limit. You cannot book more than 3.");
  } else {
    document.getElementById('lws-addCity').style.cursor = 'pointer';
    document.getElementById('lws-addCity').removeAttribute('disabled');
  }
  //pass action
  next(action);
};
const store = createStore(
  flightBookingReducer,
  applyMiddleware(flightValidation)
);

export default store;
